(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsRegisterController',TabObjectsRegisterController);

    TabObjectsRegisterController.$inject = ['$uibModalInstance', 'TabObjects', 'AlertService', 'TabFleets', 'LicenceCode'];

    function TabObjectsRegisterController($uibModalInstance, TabObjects, AlertService, TabFleets, LicenceCode) {
        var vm = this;
        vm.fleet = null;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.fleets = TabFleets.query({
            page: 0,
            size: 100
        });

        vm.register = function () {
            var body = {
                licence: vm.registrationCode,
                objectUniqueCode: vm.objectUniqueCode,
                fleet: vm.fleet
            };

            LicenceCode.active(body, onLicenceSuccess, onLicenceError);

            function onLicenceSuccess(){
                $uibModalInstance.close(true);
            }

            function onLicenceError(error) {
                if(error.status === 400) {
                    AlertService.error("Licence cannot be activated");
                }
            }

        };
    }
})();
